import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import { ActionTypes } from '../constants/ApplicationConstants';
import SelectCustomerConstants from '../constants/SelectCustomerConstants.js';

const SelectCustomerActionsTypes = SelectCustomerConstants.ActionTypes;
const CHANGE_EVENT = 'change';

let _productList = [], _isAdviserRegisteredAnnuity, _clientOin;

function loadProductList(productList) {
    _productList = productList;
}

function setClientOin(clientOin) {
    _clientOin = clientOin;
}

function setClient(client) {
    if (client) {
        _clientOin = client.oin;
    }
}

class ClientApplicationStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getProductList() {
        return _productList;
    }

    getIsAdviserRegisteredAnnuity() {
        return _isAdviserRegisteredAnnuity;
    }

    getClientOin() {
        return _clientOin;
    }

    isExisting() { 
        return window.NOA.userContext.isExisting;
    }

    shouldNavigateToAcquisition() { 
        return window.NOA.shouldNavigateToAcquisition
    }    
}

const ClientApplicationStore = new ClientApplicationStoreClass();

ClientApplicationStore.dispatchToken = AppDispatcher.register((action) => {
    switch (action.actionType) {
        case SelectCustomerActionsTypes.SET_CLIENT_OIN:
            setClientOin(action.clientOin);
            break;
        case ActionTypes.RECEIVE_PRODUCT_LIST:
            loadProductList(action.productList);
            break;
        case ActionTypes.RECEIVED_IS_PRODUCT_REGISTERED:
            _isAdviserRegisteredAnnuity = action.data;
            break;
        case SelectCustomerActionsTypes.CLIENT_RETRIEVE_COMPLETED:
            setClient(action.client);
            break;
        default:
            return true;
    }

    ClientApplicationStore.emitChange();
    return true;
});

export default ClientApplicationStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ClientApplicationStore.js